function ProductRequestReducer(state = { productRequest: '', UsersList: [], purchaseProductList: [], 
                                productRequestList: null, requestMessagesPopup:'', productRequestComments:null, 
                                popupChangeReqStatus:'', requestStatusList:null }, action) {

  switch (action.type) {

    case "FETCH_Product_Request":
      return {
        ...state,
        productRequest: action.data
      }; 
      case "SERCH_PRODUCT_REQUEST":
        return{
          ...state,
          productRequestList: action.data
        }
    case "FETCH_User_List":
      return {
        ...state,
        UsersList: action.data
      };
    case "SEARCH_PURCHACE_PRODUCTS":
      return {
        ...state,
        purchaseProductList: action.data
      };
      case "FETCH_PR_COMMENTS":
        return{
          ...state,
          productRequestComments:action.data
        }
      case "PRODUCT_REQUEST_MESSAGE_POP":
        return{
          ...state,
          requestMessagesPopup:action.data
        }
        case "POP_CHANGE_REQUEST_STATUS":
          return{
            ...state,
            popupChangeReqStatus: action.data
          }
          case "FETCH_REQUEST_STATUS":
            return {
              ...state,
            requestStatusList: action.data
            }
    default:
      return state;
  }
}

export default ProductRequestReducer;